import { Provider } from '@angular/core';

import { ZendeskApiDetailsService } from '../services';

export function provideZendeskApiDetailsService(): Provider {
  return ZendeskApiDetailsService;
}
